import ProgramsModalContainer from './containers/ProgramsModalContainer'

export default ProgramsModalContainer
